module.exports = __webpack_public_path__ + "static/media/Machine_test _mr.042b269a.jpg";